import { formatRelative } from "date-fns";
import { ptBR } from "date-fns/locale";

export function RelativeDate({ date }: { date: string }) {
  return formatRelative(new Date(date), new Date(), { locale: ptBR });
}
